import React, { useState, useContext, useRef, useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { AppDataContext, VLink } from "../AppDataContext"
import useNetwork from '../../useNetwork';
import { Helmet } from "react-helmet";
import useInfiniteScroll from "../../useInfiniteScroll";
import { LotTile } from '../auction/LotTile';
import { BidDialog } from '../auction/BidDialog';
import { Modal } from 'bootstrap';
import { urlEncodeText, computeSystemTimeDifference, getSecondsToTime, toGMT } from '../../helpers';
import { Loader } from '../Loader';
import CurrencyFormat from 'react-currency-format';
import { ConfirmDialog } from '../ConfirmDialog';

export function Searches(props) {

	const context = useContext(AppDataContext);
	const { loading, networkError, netRequest, netRenderError } = useNetwork(false);
	const history = useHistory();

	const startIx = useRef(0);
	const pageSize = 8;


	const [isFetching, setIsFetching, isDone, setIsDone] = useInfiniteScroll(fetchSearches);
	const [endReached, setEndReached] = useState(false);
	const [totalCount, setTotalCount] = useState(null);
	const totalCountRef = useRef(null);

	const [sellers, setSellers] = useState([]);

	// this useEffect has [] as the parms, so only gets call on didMount
	useEffect(() => {

		fetchSearches(true);

		// clean up if this effect gets called again
		return () => {
		};
	}, []);


	function fetchSearches(fromBeginning) {

		const getNextSearches = async (startingAt) => {
			setTotalCount(0);
			//if (totalCountRef.current == null || startingAt < totalCountRef.current) {
			//	let itemsToFetch = pageSize;

			//	const url = 'api/site/getsellers/' + startingAt + '/' + itemsToFetch;
			//	console.log(url);
			//	const response = await netRequest(url);

			//	if (response.data != null) {

			//		totalCountRef.current = response.data.totalCount;
			//		setTotalCount(response.data.totalCount);

			//		// set our next starting point
			//		startIx.current = startingAt + itemsToFetch;

			//		const endReached = startIx.current >= response.data.totalCount;
			//		setIsDone(endReached);
			//		setEndReached(endReached);

			//		if (startingAt == 0)
			//			setSellers(response.data.sellers);
			//		else
			//			setSellers([...sellers, ...response.data.sellers]);
			//	}
			//} else {
			//	setEndReached(true);
			//}
			setIsFetching(false);
		};

		// if the infinite scroll calls us, the first param is false
		let startingAt = fromBeginning === true ? 0 : startIx.current;

		getNextSearches(startingAt);
	};

	if (context.isLoggedIn == false)
		return <Redirect to="/" />

	return (
		<>
			<Helmet>
				<title>Searches</title>
			</Helmet>

			<div class="tab-pane container h-100 py-3 px-0 active" id="auctioneers">
				<div class="btn-group">
					<button class="btn btn-primary active">Searches</button>
					<VLink to="/dashboard/auctioneers" class="btn btn-secondary">Auctioneers</VLink>
				</div>
                <div class="row mt-3">
                    Not yet implemented

					{isFetching && !isDone && <div>Fetching More...</div>}
					{(totalCount > 0 && endReached) && <div class="col-12"><p class="text-center end-of-auction">End of Auctioneers</p></div>}
					{(!isFetching && totalCount > 0 && !endReached) &&
						<div class="col-12 mb-3 text-end">

							<button onClick={fetchSearches} class="btn btn-secondary" title="Show More...">
								Show More <i class="bi bi-arrow-right-short"></i>
							</button>
						</div>
					}
					{totalCount == 0 && <div class="col-12"><p class="text-center end-of-auction">You have not saved any searches</p></div>}

                </div>


            </div>

		</>
    );

}
